const FSXPERT_ARTIFACT_PATHS = {
    widget: 'wlmfsxpert-widget/fsxpert-widget.js',
    button: 'wlmfsxpert-button/fsxpert-button.js',
    mainWidget: 'wlmfsxpert/main-widget.js',
} as const;

const artifactCache = new Map<string, Promise<unknown>>();

const getDomain = (): string =>
    import.meta.env.VITE_WLM_FRONTEND_URL || location.origin;

const getArtifactUrl = (path: string): string =>
    `${getDomain().replace(/\/$/, '')}/${path}`;

const preloadArtifact = (url: string): void => {
    if (artifactCache.has(url)) {
        return;
    }

    artifactCache.set(
        url,
        import(/* @vite-ignore */ url).catch((error: unknown) => {
            artifactCache.delete(url);
            console.warn(`Failed to preload FSxpert artifact ${url}`, error);
        })
    );
};

const scheduleIdle = (work: () => void): number => {
    if (typeof window.requestIdleCallback === 'function') {
        return window.requestIdleCallback(work);
    }
    return window.setTimeout(work, 1);
};

/** Starts fetching the npm wrapper module as early as possible. */
export const preloadFSxpertModule = (): void => {
    void import('@tlveng/fsxpert-sdk').catch((error: unknown) => {
        console.warn('Failed to preload FSxpert module @tlveng/fsxpert-sdk', error);
    });
};

/**
 * Prefetches standalone FSxpert bundles into the browser module cache.
 * Homepage search (`main-widget.js`) and the bookmark widget bundle load
 * immediately; the button bundle is deferred to idle time.
 */
export const preloadFSxpertArtifacts = (): void => {
    const domain = getDomain();
    if (!domain) {
        return;
    }

    preloadArtifact(getArtifactUrl(FSXPERT_ARTIFACT_PATHS.mainWidget));
    preloadArtifact(getArtifactUrl(FSXPERT_ARTIFACT_PATHS.widget));

    scheduleIdle(() => {
        preloadArtifact(getArtifactUrl(FSXPERT_ARTIFACT_PATHS.button));
    });
};
